import styles from './style.module.css';

interface Material {
  url: string;
  name?: string;
  title?: string;
}

interface SupportingMaterialsProps {
  materials: Material[];
  primaryColor: string;
}

export function SupportingMaterials({
  materials,
  primaryColor,
}: SupportingMaterialsProps) {
  if (!materials || materials.length === 0) return null;

  return (
    <div className="mt-4">
      <div className={styles.header} style={{ backgroundColor: primaryColor }}>
        MATERIAL DE APOIO
      </div>
      <div className={styles.list}>
        {materials.map((material, index) => (
          <div
            key={index}
            className={styles.row}
            style={{
              marginBottom: index < materials.length - 1 ? '10px' : '0',
            }}
          >
            <span className={styles.materialName}>
              {material.name || material.title || `Arquivo ${index + 1}`}
            </span>
            <a
              href={material.url}
              download
              className={styles.link}
              style={{ backgroundColor: primaryColor }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Acessar
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
